import type { Disposition } from 'tendril-v2/src/Presentation/Views/types/disposition-mapping.type';

export function removeDefaultDisposition(mappings: Disposition[]): Disposition[] {
  return mappings.filter((mapping) => !mapping.defaultName.includes('default'));
}
